import type { AppNotification } from './api';

/**
 * Where a tap on a bell row or a toast goes. An owner alert carries its exact page in
 * `meta.url` (worker alertFanout: an absolute https://app.storiz.ma/admin/… link, the same one
 * the push opens). Only its path is kept, and only an /admin path — never an outside link.
 * Otherwise the order page, as before.
 */
export function notificationHref(n: Pick<AppNotification, 'shopify_order_id' | 'meta'>): string | null {
  const raw = n.meta?.url;
  if (typeof raw === 'string' && raw) {
    try {
      const u = new URL(raw, 'https://app.storiz.ma');
      if ((u.protocol === 'https:' || u.protocol === 'http:') && /^\/admin(\/|$)/.test(u.pathname)) {
        return u.pathname + u.search + u.hash;
      }
    } catch { /* not a URL — fall back to the order */ }
  }
  return n.shopify_order_id ? `/admin/orders/${n.shopify_order_id}` : null;
}
